export { InfoDetailText } from './InfoDetailText';
